import { Component, OnInit } from '@angular/core';
import { CognitoServiceService } from '../../services/cognito-service.service';
import { UtilitiesService } from '../../services/utilities.service';
import { HttpService } from '../../services/http.service';
import { CommonService } from '../../services/common/common.service';
import { FormDefinitionsService } from '../../services/forms/form-definitions.service';
import { FormActionsService } from 'src/app/services/forms/form-actions.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  showUserEdit: boolean = false;
  showChangePassword: boolean = false;
  showChangePin: boolean = false;
  userInfo: any = {};
  userTempInfo: any = {};
  breadcrumb: { "label": string; "link": any[]; }[] = [];
  profileEditForm: any;
  changePasswordForm: any;
  changeConsentPinForm: any;
  isEditForm = true;

  constructor(private cognito: CognitoServiceService,
              private util: UtilitiesService,
              private http: HttpService,
              private commonService: CommonService,
              private formDefinitionsService: FormDefinitionsService,
              private formActionService: FormActionsService,
              private route: Router
            ) { }

  ngOnInit() {
    this.getUserData();
    this.setBreadcrumb();
    this.profileEditForm = this.formDefinitionsService.profileEditForm
    this.changePasswordForm = this.formDefinitionsService.changePasswordForm
    this.changeConsentPinForm = this.formDefinitionsService.changeConsentPinForm
  }

  getUserData() {
    this.cognito.getUserData((data)=> {
      this.formatUserInfoData(data);
    });
  }

  formatUserInfoData(data) {
    this.userInfo.username = data.Username + this.commonService.vuaExtension;
    this.userInfo.vua = data.Username;
    data.UserAttributes.forEach(element => {
      if(element.Name == 'phone_number') {
        this.userInfo.phone_number = element.Value.split(this.commonService.phoneExtension).pop();
      } else {
        this.userInfo[element.Name] = element.Value;
      }
    });
  }

  profileEdit(event) {
    let form = event.formData;
    let userObj: any = {};
    userObj.name = form.controls.name.value;
    userObj.email = form.controls.email.value;
    userObj.phone_number = form.controls.phone_number.value;
    this.cognito.updateUserAttributes(userObj, (data)=> {
      form.reset();
      this.util.changeToastState(true);
      this.getUserData();
    });
    this.showUserEdit = false;
  }

  manageIdentiers() {
    this.route.navigate(['/identifier-list']);
  }

  changePassword(event) {
    let form = event.formData;
    let userObj: any = {};
    userObj.oldpassword = form.controls.oldpassword.value;
    userObj.newpassword = form.controls.newpassword.value;
    this.cognito.changePassword(userObj, (data)=> {
      form.reset();
      this.setUpInitialState();
      this.util.changeToastState(true);
    });
  }

  editUserInfo() {
    this.setUpInitialState();

    this.userTempInfo = JSON.parse(JSON.stringify(this.userInfo));
    this.showUserEdit=true;
    this.formActionService.fillFormInUI(this.profileEditForm.formGroup, this.userTempInfo);
  }

  cancelProfileEdit() {
    this.showUserEdit=false;
  }

  setUpInitialState() {
    this.showUserEdit = false;
    this.showChangePassword = false;
    this.showChangePin = false;
  }
  
  changePasswordEvent() {
    this.setUpInitialState(); 
    this.showChangePassword=true;
  }

  consentPinChangeEvent(){
    this.setUpInitialState();
    this.showChangePin=true;
  }

  /**
   * 
   * @param form 
   * Function is used to change consent pin when it is already created
   */
  changeConsentPin(event){
    let form = event.formData;
    let oldPin=form.controls.oldpin.value;
    let newPin=form.controls.newpin.value;
    if(oldPin==newPin){
      this.showGlobalPopup("New PIN should be different from old PIN");
    }else{
      let options={
        type :'put',
        url  :'changeconsentpin',
        includeUserSession: true,
        isDeveloper:true,
        data:{
          oldPin:oldPin,
          newPin:newPin
        }
      }
      this.http.makeHttpRequest(options).subscribe((res)=>{
        form.reset();
        this.setUpInitialState();
        this.showGlobalPopup(res['message']);
      });
    }
  }

  /**
   * 
   * @param form 
   * Function is used to create consent pin when user has not created for confirming the consent
   */
  createConsentPin(form){
    let options={
      type :'post',
      url  :'createconsentpin',
      includeUserSession: true,
      isDeveloper:true,
      data:{
        userID:'af10eef3-e15b-4182-85bc-68bafd829407',
        newPin:form.controls.createdpin.value
      }
    }
    this.http.makeHttpRequest(options).subscribe((res)=>{
      this.showGlobalPopup(res['message']);
    });
  }

  setBreadcrumb() { 
    this.breadcrumb = [
      { "label": "Profile", "link": ["/dashboard"] },
    ];
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }
    
    this.commonService.showGlobalMessage(popuptext);
  }

}
